// packages/shared-hooks/src/lead-activity/useLeadFiles.ts
//
// `GET /leads/:leadId/files` — live (non-soft-deleted) file rows plus
// usage envelope (`count`, `maxPerLead`, `maxBytesPerFile`). The UI
// uses `usage` to render the X/N badge and to short-circuit the upload
// flow before a presigned URL is even minted (#1085).
import { useQuery } from '@tanstack/react-query';
import { LeadFilesListResponseSchema, type LeadFilesListResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from './keys.js';

export function useLeadFiles(leadId: string | null) {
  const client = useApiClient();
  return useQuery<LeadFilesListResponse>({
    queryKey: leadActivityKeys.files(leadId ?? ''),
    enabled: !!leadId,
    queryFn: ({ signal }) =>
      client.get<LeadFilesListResponse>(
        `/leads/${leadId}/files`,
        { signal },
        LeadFilesListResponseSchema,
      ),
  });
}
